<template>
    <div>
        <b-btn class="btn-card-action btn-card-action-light-danger my-1" v-if="purchase.actions.customer.delete" @click="showModal = true"> Удалить </b-btn>
        <b-modal ref="publish-modal" v-model="showModal" size="lg" centered hide-header-close no-close-on-backdrop no-close-on-esc title="Удалить закупку">
            <div>
                <p>
                    Вы действительно хотите удалить закупку <strong>{{ purchase.reg_number }}</strong
                    >?
                </p>
                <p>
                    <template v-if="purchase.purchase_object"> <strong>Объект закупки</strong>: {{ purchase.purchase_object }}<br /> </template>
                    <template v-if="purchase.deliverable_group_title"> <strong>Предмет закупки</strong>: {{ purchase.deliverable_group_title }}<br /> </template>
                    <template v-if="purchase.start_price"> <strong>Сумма закупки, руб.</strong>: {{ $formatPrice(purchase.start_price) }}<br /> </template>
                </p>
            </div>
            <div slot="modal-footer" class="w-100 text-right">
                <b-button class="text-uppercase mr-2" variant="custom-outline-secondary" @click="showModal = false">Отмена</b-button>&nbsp;
                <b-button class="text-uppercase" variant="custom-danger" @click="deletePurchase">Удалить</b-button>
            </div>
        </b-modal>
    </div>
</template>

<script>
export default {
    name: 'cabinet-commercial-notice-card-delete-button',
    props: {
        purchase: {
            type: Object
        }
    },
    data() {
        return {
            showModal: false
        };
    },
    methods: {
        async deletePurchase() {
            if (await this.$api.products.commercial.purchases.delete(this.purchase.id)) {
                this.showModal = false;
                this.$emit('delete');
            }
        }
    }
};
</script>
